export default __webpack_public_path__ + "static/media/LightingRightFixed.f5fcca83.png";